import { render, staticRenderFns } from "./decLeftNav.vue?vue&type=template&id=72559495&scoped=true&"
import script from "./decLeftNav.vue?vue&type=script&lang=js&"
export * from "./decLeftNav.vue?vue&type=script&lang=js&"
import style0 from "./decLeftNav.vue?vue&type=style&index=0&id=72559495&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72559495",
  null
  
)

export default component.exports